const onlineStatsDefaultState = {
    data: [],
    singleItem: {},
    loading: false,
    error: false,
    success: false,
    successMessage: '',
    prioritySuccess: false,
    errorMessage: null
};

const onlineStatsReducer = (state = onlineStatsDefaultState, action) => {
    switch (action.type) {
        case 'START_GET_ONLINE_STAT':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'GET_ONLINE_STAT_SUCCESS':
            return {
                ...state,
                singleItem: action.onlineStat,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'START_GET_ONLINE_STATS':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                success: false
            };
        case 'GET_ONLINE_STATS_SUCCESS':
            return {
                ...state,
                data: action.onlineStats,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'CREATE_ONLINE_STAT_SUCCESS':
            return {
                ...state,
                data: [action.onlineStat, ...state.data], // Add new item to the data array
                singleItem: action.onlineStat,
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'News Alert has been updated',
            };
        case 'START_ONLINE_STAT_UPDATE':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'UPDATE_ONLINE_STAT_SUCCESS':
            return {
                ...state,
                data: state.data.map((onlineStat) => {
                    if (onlineStat.id === action.onlineStat.id) {
                        console.log('got match');
                        return {
                            ...onlineStat,
                            ...action.onlineStat /// add object to array
                        }
                    } else {
                        return onlineStat;
                    }
                }),
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Email content stat has been updated',
            };
        case 'START_ONLINE_STAT_PRIORITY_UPDATE':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                prioritySuccess: false
            };
        case 'UPDATE_ONLINE_STAT_PRIORITY_SUCCESS': {
            const { itemsToUpdate, priority } = action.formattedStats;
            const idSet = new Set(itemsToUpdate);

            return {
                ...state,
                data: state.data.map((onlineStat) =>
                    idSet.has(onlineStat.id)
                        ? { ...onlineStat, priority }
                        : onlineStat
                ),
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Online Stats have been updated',
                prioritySuccess: true
            };
        }
        case 'START_REMOVE_ONLINE_STAT':
            return {
                ...state,
                loading: true,
                success: false,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'REMOVE_ONLINE_STAT_SUCCESS':
            return {
                ...state,
                data: state.data.filter(onlineStat => onlineStat.id !== Number(action.onlineStatId)),
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Your Email Content Stat has been removed!',
            };
        case 'STATS_EMAIL_CLEAR_SUCCESS':
            return {
                ...state,
                success: false
            };
        case 'SHOW_ERROR':
            return {
                ...state,
                loading: false,
                error: true,
                successMessage: '',
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};

export default onlineStatsReducer;